import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, signal, WritableSignal } from '@angular/core';
import { IntegrationPushBackService } from 'src/app/services/integration-pushback.service';
import { IntegrationRunTimeService } from 'src/app/services/integration-runtime.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TypeConstantService } from 'src/app/services/type-constant.service';
import { ToastService } from '../../../../services/toast.service';
import { IntegrationRunTime } from 'src/app/models/integration-runtime';
import { IntegrationPushBack } from 'src/app/models/integration-pushback';
import { Integration } from 'src/app/models/integration';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { LTDateTimePickerComponent } from 'src/app/features/lt-input/lt-time-picker/components/lt-datetimepicker/lt-datetimepicker.component';

@Component({
  selector: 'app-integration-pushback-add',
  templateUrl: './integration-pushback-add.component.html',
  styleUrl: './integration-pushback-add.component.scss',
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    LTDateTimePickerComponent,
  ],
})
export class IntegrationPushbackAddComponent implements OnInit, OnDestroy {
  componentDestroyed$: Subject<boolean> = new Subject();
  @Input() showBackButton = false;
  @Input() integrationRunTimes: IntegrationRunTime[] = [];
  @Input() integration: Integration = null;

  selectedPushBack: IntegrationPushBack = null;
  @Input() set updatingItem(value: IntegrationPushBack | null) {
    if (value && value !== null) {
      this.selectedPushBack = value;
      this.selectedRunTime = this.integrationRunTimes?.find(rt => rt.integrationRunTimeId == this.selectedPushBack.integrationRunTimeId);
      this.pushBackLastRunTimeDateInput = new Date(this.selectedPushBack.pushBackLastRunTimeDate);
      this.jiraStoryURLInput = this.selectedPushBack.jiraStoryURL;
      this.commentInput = this.selectedPushBack.comment;
      this.triggerDateInput = new Date(this.selectedPushBack.triggerDate);
    }
  }

  @Output() itemAdded = new EventEmitter<IntegrationPushBack>();
  @Output() itemUpdated = new EventEmitter<IntegrationPushBack>();
  @Output() cancel = new EventEmitter<boolean>();

  allRunTimes: WritableSignal<IntegrationRunTime[]> = signal<IntegrationRunTime[]>([]);

  selectedRunTime: IntegrationRunTime = null;
  pushBackLastRunTimeDateInput: Date = null;
  jiraStoryURLInput: string = null;
  commentInput: string = null;
  triggerDateInput: Date = null;

  savingIntegrationPushBack = false;

  constructor(
    protected typeService: TypeConstantService,
    protected toastService: ToastService,
    private integrationPushBackService: IntegrationPushBackService,
    private runTimeService: IntegrationRunTimeService,
  ) { }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  goBack(): void {
    this.cancel.emit(null);
  }

  ngOnInit(): void {

    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);

    this.pushBackLastRunTimeDateInput = new Date(today);
    this.triggerDateInput = new Date(today);
    
    this.getRunTimes();
  }

  getRunTimes(): void {
    if (this.integrationRunTimes != null && this.integrationRunTimes.length > 0) {
      //this.allRunTimes = this.integrationRunTimes.filter(r => !(r.destinationEndpointName == "NoDestination") && !r.importTypeDescription.includes("Cache"));
      this.allRunTimes.set(this.integrationRunTimes.filter(r => !(r.destinationEndpointName == 'NoDestination') && !r.importTypeDescription.includes('Cache')));

      if (this.selectedRunTime == null && this.allRunTimes.length > 0) {
        this.selectedRunTime = this.allRunTimes[0];
      }
    }
    else {
      this.allRunTimes.set([]);
      // update to get by integration
      if (this.integration != null)
      {
        this.runTimeService.getAllIntegrationRunTimesByIntegration(this.integration.integrationId)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe(value => {
          this.allRunTimes.set(value.filter(r => !(r.destinationEndpointName == 'NoDestination') && !r.importTypeDescription.includes('Cache')));
          if (this.selectedRunTime != null || this.allRunTimes.length == 0) {
            return;
          }

          if (this.selectedPushBack == null)
          {
            this.selectedRunTime = this.allRunTimes().find(rt => rt.integrationRunTimeId == this.selectedPushBack.integrationRunTimeId);
          }
          else
          {
            this.selectedRunTime = this.allRunTimes[0];
          }
        });
      }
    }
  }

  addIntegrationPushBack(): void {
    this.savingIntegrationPushBack = true;

    if (this.triggerDateInput == null) {
      this.toastService.toastCreate('No Trigger Date Selected', 'Warning', {
          autoClose: false,
      });

      this.savingIntegrationPushBack = false;
    }
    else if (this.pushBackLastRunTimeDateInput == null) {
      this.toastService.toastCreate('No PushBack Date Selected', 'Warning', {
          autoClose: false,
      });

      this.savingIntegrationPushBack = false;
    }
    else {
      var newPushBack = {
          integrationRunTimeId: this.selectedRunTime.integrationRunTimeId,
          active: true,
          pushBackLastRunTimeDate: this.pushBackLastRunTimeDateInput,
          triggerDate: this.triggerDateInput,
          jiraStoryURL: this.jiraStoryURLInput,
          comment: this.commentInput,
      };

      this.integrationPushBackService.addIntegrationPushBack(newPushBack)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe({
        next: (value) => {
          // on success
          if (this.integration != null && this.integration.name != null)
          {
            this.toastService.toastCreate('Successfully added the pushback for ' + this.integration.name + ' runtime: ' + this.selectedRunTime.importTypeDescription + ' ' + this.selectedRunTime.destinationEndpointName + '.', 'Success', {
                autoClose: false,
            });
          }
          else
          {
            this.toastService.toastCreate('Successfully added the pushback - runtime: ' + this.selectedRunTime.importTypeDescription + ' ' + this.selectedRunTime.destinationEndpointName + '.', 'Success', {
              autoClose: false,
            });
          }

          newPushBack['integrationPushBackId'] = value;
          this.itemAdded.emit(newPushBack);

          this.savingIntegrationPushBack = false;
        },
        error: (_error) => {
          this.savingIntegrationPushBack = false;
          this.toastService.toastCreate('Failed to add the pushback for ' + this.integration.name + ' runtime: ' + this.selectedRunTime.importTypeDescription + ' ' + this.selectedRunTime.destinationEndpointName + '.', 'Danger', {
            autoClose: false,
          });
        },
    });
    }
  }

  updateIntegrationPushBack(): void {
    this.savingIntegrationPushBack = true;

    if (this.triggerDateInput == null) {
      this.toastService.toastCreate('No Trigger Date Selected', 'Warning', {
          autoClose: false,
      });

      this.savingIntegrationPushBack = false;
    }
    else if (this.pushBackLastRunTimeDateInput == null) {
      this.toastService.toastCreate('No PushBack Date Selected', 'Warning', {
          autoClose: false,
      });

      this.savingIntegrationPushBack = false;
    }
    else {
      var updatedPushBack = {
          integrationPushBackId: this.selectedPushBack.integrationPushBackId,
          integrationRunTimeId: this.selectedRunTime.integrationRunTimeId,
          active: true,
          pushBackLastRunTimeDate: this.pushBackLastRunTimeDateInput,
          triggerDate: this.triggerDateInput,
          jiraStoryURL: this.jiraStoryURLInput,
          comment: this.commentInput,
      };

      this.integrationPushBackService.updateIntegrationPushBack(updatedPushBack)
        .pipe(takeUntil(this.componentDestroyed$))
        .subscribe({
        next: (value) => {
          // on success
          if (this.integration != null && this.integration.name != null)
          {
            this.toastService.toastCreate('Successfully updated the pushback for ' + this.integration.name + ' runtime: ' + this.selectedRunTime.importTypeDescription + ' ' + this.selectedRunTime.destinationEndpointName + '.', 'Success', {
                autoClose: false,
            });
          }
          else
          {
            this.toastService.toastCreate('Successfully updated the pushback - runtime: ' + this.selectedRunTime.importTypeDescription + ' ' + this.selectedRunTime.destinationEndpointName + '.', 'Success', {
              autoClose: false,
            });
          }

          this.itemUpdated.emit(updatedPushBack);

          this.savingIntegrationPushBack = false;
        },
        error: (_error) => {
          this.savingIntegrationPushBack = false;
          this.toastService.toastCreate('Failed to updated the pushback for ' + this.integration.name + ' runtime: ' + this.selectedRunTime.importTypeDescription + ' ' + this.selectedRunTime.destinationEndpointName + '.', 'Danger', {
            autoClose: false,
          });
        },
    });
    }
  }
}
